import firebase from 'firebase/app';
import 'firebase/messaging';
import { firebaseConfig } from '~/config/constants';

export default firebase.initializeApp(firebaseConfig);
